import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Divider, Drawer, Skeleton, Space, Typography } from 'antd';

import type { NExtendedMessage } from '@app/components/ExtendedMessage/ExtendedMessage.types';
import { PREFIX } from '@app/constants';
import { PointWithKeyWord } from '@app/features/SendoutCreationModal/components/SendMessageModal/components/PointWithKeyWord';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';

const { Text } = Typography;

export const KeyWords: NExtendedMessage.KeyWords = ({
  isKeywordsLoading,
  sendoutKeywords,
  isKeyWordsOpen,
  setIsKeyWordsOpen,
  addExtraTextToMessage,
  getDescriptionTag,
}) => {
  return (
    <Drawer
      title="Ключи и форматирование текста"
      className={`${PREFIX}text-drawers`}
      open={isKeyWordsOpen}
      mask={false}
      onClose={() => setIsKeyWordsOpen(false)}
    >
      <Space direction="vertical" size={'small'}>
        <Text>
          Вы можете подставить в сообщение любую информацию. Для этого вставьте
          в текст любое из ключевых слов, приведенных ниже.
        </Text>
        {isKeywordsLoading ? (
          <Skeleton active title={false} paragraph={{ rows: 10 }} />
        ) : (
          sendoutKeywords?.map(({ Keyword, Description }, index) => {
            const props = {
              componentKey: index,
              keyWord: Keyword,
              description: Description,
              addExtraTextToMessage,
              getDescriptionTag,
            };

            return <PointWithKeyWord key={`${Keyword}-${index}`} {...props} />;
          })
        )}
      </Space>
      <Divider />

      <Space direction="vertical" size={'small'}>
        <Text>
          Вы можете разнообразить отправляемые сообщения добавлением синонимов в
          фигурных скобках {'{ }'}, разделяя их символом |. Например:
        </Text>
        <Text strong>{'{Здравствуйте|Добрый день|Приветствую}'}</Text>
      </Space>
      <Divider />

      <Text>
        <FontAwesomeIcon
          icon={'fa-solid fa-circle-info' as IconProp}
          size="lg"
          className="info-icon"
        />{' '}
        Вы можете нажать на ключ или спецсимвол и он подставится в текст. Чтобы
        добавить форматирование, выделите текст и нажмите символ форматирования,
        например, {'{'}*текст*{'}'}.
      </Text>
    </Drawer>
  );
};
